import { sizeBoolean } from 'office-ui-fabric-react/lib/Persona';
import { FontSizes } from '../FluentType';
import { FontWeights } from 'office-ui-fabric-react/lib/Styling';
export var PersonaStyles = function (props) {
    var size = sizeBoolean(props.size);
    return {
        primaryText: [
            size.isSize100 && {
                fontSize: FontSizes.size20,
                fontWeight: FontWeights.regular,
            },
            size.isSize72 && {
                fontSize: FontSizes.size20,
            },
            size.isSize48 && {
                fontSize: FontSizes.size16,
            },
        ],
        tertiaryText: {
            fontSize: FontSizes.size14,
        },
    };
};
//# sourceMappingURL=Persona.styles.js.map